"use client";
import { useState } from "react";
import { Icon } from "@zapier/zinnia-icons";
import { Text } from "@zapier/design-system";
import { useCopilotChat } from "@zapier/ai-toolkit/client";

/** Possible thresholds — one is randomly picked per session (component mount). */
const ANIMATE_THRESHOLDS = [2, 3, 4, 5, 6, 7];

const wiggleKeyframes = `
@keyframes nudge-wiggle {
  0% { transform: rotate(0deg) scale(1); }
  10% { transform: rotate(-6deg) scale(1.15); }
  20% { transform: rotate(6deg) scale(1.25); }
  30% { transform: rotate(-4deg) scale(1.3); }
  40% { transform: rotate(4deg) scale(1.25); }
  50% { transform: rotate(-2deg) scale(1.15); }
  60% { transform: rotate(2deg) scale(1.1); }
  70% { transform: rotate(-1deg) scale(1.05); }
  80% { transform: rotate(1deg) scale(1.02); }
  90% { transform: rotate(0deg) scale(1.01); }
  100% { transform: rotate(0deg) scale(1); }
}
`;

function pickRandomThreshold() {
  return ANIMATE_THRESHOLDS[
    Math.floor(Math.random() * ANIMATE_THRESHOLDS.length)
  ];
}

export default function FeedbackNudge() {
  const [animateThreshold] = useState(pickRandomThreshold);
  const { messages } = useCopilotChat();

  // Count assistant replies, excluding the initial welcome message
  const assistantReplyCount = messages.filter(
    (msg) => msg.role === "assistant" && msg.id !== "welcome-message",
  ).length;

  const shouldAnimate = assistantReplyCount > animateThreshold;

  return (
    <>
      {shouldAnimate && <style>{wiggleKeyframes}</style>}
      <div
        style={{
          backgroundColor: "#f9f9f8",
          borderTop: "1px solid #d4d2cd",
        }}
      >
        <div
          style={{
            maxWidth: "720px",
            margin: "0 auto",
            padding: "8px 24px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "8px",
          }}
        >
          <span
            style={{
              display: "inline-block",
              fontSize: "16px",
              animation: shouldAnimate
                ? "nudge-wiggle 1s ease-in-out 1s 2"
                : "none",
            }}
            aria-hidden="true"
          >
            👋
          </span>
          <Text
            type="MinimalPrint1"
            style={{ display: "flex", alignItems: "center", gap: "4px" }}
          >
            Could you leave some feedback (
            <Icon name="ratingThumbsUp" size="14px" />
            /
            <Icon name="ratingThumbsDown" size="14px" />) on this conversation?
          </Text>
        </div>
      </div>
    </>
  );
}
